import React, { useState } from 'react'
import { Button, Popup } from 'semantic-ui-react'
import RoutingList from './RoutingList'
import { useTranslation } from '@hooks/useTranslation'
import useDistanceFromParent from '@EUForms/hooks/useDistanceFromParent'

const containerHeading = ({
  isFormDisabled,
  headerName,
  AddItem,
  limit,
  dataList,
  setIsAutoFocus,
  disableAddBtn,
  
}) => {
  const translate = useTranslation();
  return (
  <div className='headerStyle'>
    <span>{translate(headerName)}</span>
    {!disableAddBtn &&
    <Button
      disabled={isFormDisabled || (dataList.length < limit ? false : true)}
      size='tiny'
      id='addBtn'
      onClick={() => {
        setIsAutoFocus(true)
        AddItem()
      }}
    > 
      ADD
    </Button>}
  </div>
)}

const RoutingModal = (props) => {
  const [autoFocus, setIsAutoFocus] = useState(false)
  // changes to enable copy document feature
  const [open, setOpen] = useState(false)
  const [isCopyEnabled, setCopyEnabled] = useState(false)
  const handleClose = () => setOpen(false)
  const handleCopyEnabled = () => setCopyEnabled(prevState=> !prevState)
  const {
    headerName,
    isFormDisabled,
    triggerContent,
    valueKey,
    limit,
    AddItem,
    saveData,
    updateData,
    deleteData,
    dataList,
    dataSource,
    fieldType='input',
    disableAddBtn = false,
    copyDocument=null,
    ...rest
  } = props
  
  const dataListLength = dataList?.length
  const distanceFromParent = useDistanceFromParent(
    'routingCountryParentElement',
    'addcountryofroutingButton',
    [dataListLength]
  )

  const translate = useTranslation();

  return (
    <Popup
      pinned
      on='click'
      open={open}
      onOpen={()=> setOpen(true)}
      onClose={() => {
        if(!copyDocument) handleClose() 
        if(copyDocument && !isCopyEnabled) handleClose()       
        setIsAutoFocus(false)
      }}
      className='containerModal'
      hideOnScroll={true}
      disabled={isFormDisabled}
      trigger={
        triggerContent ? (
          triggerContent
        ) : (
          <span>
            <Button
              id='addcountryofroutingButton'
              style={{
                height: '20px',
                width: '41px',
                marginTop: '5px',
                color: '#2185d0',
                fontSize: '9px',
                border: '1px solid #2185d0',
                backgroundColor: 'white',
                textAlign: 'center',
                padding: '1px 0px 0px 0px',
                position: 'relative',
                marginLeft: '4px',
                marginBottom: '5px',
              }}  
              disabled={isFormDisabled}
            >
              {translate("ADD")}
            </Button>
          </span>
        )
      }
      header={containerHeading({
        isFormDisabled,
        headerName,
        AddItem,
        limit,
        dataList,
        setIsAutoFocus,
        disableAddBtn,
      })}
      position={`top ${distanceFromParent>150?'right':'left'}`}
      content={
        <RoutingList
          isFormDisabled={isFormDisabled}
          valueKey={valueKey}
          AddItem={AddItem}
          saveData={saveData}
          updateData={updateData}
          deleteData={deleteData}
          dataList={dataList}
          dataSource={dataSource}
          autoFocus={autoFocus}
          fieldType={fieldType}
          copyDocument={copyDocument}
          handleCopyEnabled={handleCopyEnabled}
          {...rest}
        />
      }
    />
  )
}
export default RoutingModal
